import React from 'react';
import { Link } from "react-router-dom";

export const BadgeInstructions = () => {
  return (
    <div className="bg-blue-50 p-4 rounded-lg">
      <h4 className="font-medium text-blue-900 mb-2">How to add this badge</h4>
      <ol className="text-sm text-blue-800 space-y-2 list-decimal pl-4">
        <li>Copy the embed code above</li>
        <li>Paste it into your website's HTML where you want the badge to appear</li>
        <li>The badge will automatically display with your trusted status</li>
      </ol>
      <Link 
        to="/badge-info" 
        className="inline-block mt-3 text-sm text-blue-600 hover:text-blue-800"
      >
        Need help? View our step-by-step guide →
      </Link>
    </div>
  );
};